module.exports = __webpack_public_path__ + "assets/media/email-sent.f23dff27.svg";